import { __decorate, __metadata } from "tslib";
import { FullFilledGeoLocation, GeoProviderEnum } from '@goparrot/common';
import { Expose } from 'class-transformer';
import { IsOptional } from 'class-validator';
import { StoreExposeGroup } from '../interface';
export class PatchStoreGeoLocationDto extends FullFilledGeoLocation {
}
__decorate([
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH, StoreExposeGroup.CREATE] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchStoreGeoLocationDto.prototype, "formattedAddress", void 0);
__decorate([
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH, StoreExposeGroup.CREATE] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    __metadata("design:type", Number)
], PatchStoreGeoLocationDto.prototype, "latitude", void 0);
__decorate([
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH, StoreExposeGroup.CREATE] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    __metadata("design:type", Number)
], PatchStoreGeoLocationDto.prototype, "longitude", void 0);
__decorate([
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH, StoreExposeGroup.CREATE] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchStoreGeoLocationDto.prototype, "country", void 0);
__decorate([
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH, StoreExposeGroup.CREATE] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchStoreGeoLocationDto.prototype, "countryCode", void 0);
__decorate([
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH, StoreExposeGroup.CREATE] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchStoreGeoLocationDto.prototype, "state", void 0);
__decorate([
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH, StoreExposeGroup.CREATE] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchStoreGeoLocationDto.prototype, "stateCode", void 0);
__decorate([
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH, StoreExposeGroup.CREATE] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchStoreGeoLocationDto.prototype, "city", void 0);
__decorate([
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH, StoreExposeGroup.CREATE] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchStoreGeoLocationDto.prototype, "postalCode", void 0);
__decorate([
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH, StoreExposeGroup.CREATE] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchStoreGeoLocationDto.prototype, "streetName", void 0);
__decorate([
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH, StoreExposeGroup.CREATE] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchStoreGeoLocationDto.prototype, "houseNumber", void 0);
__decorate([
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH, StoreExposeGroup.CREATE] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchStoreGeoLocationDto.prototype, "provider", void 0);
__decorate([
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH, StoreExposeGroup.CREATE] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchStoreGeoLocationDto.prototype, "placeId", void 0);
//# sourceMappingURL=PatchStoreGeoLocationDto.js.map